import type { ReactNode } from "react";
import { cn } from "@synthesis/shared-utils";

/** Тело модалки ЛК: отступы 32px, колонка с gap 24px (по макетам). */
export const AdminModalBody = ({ children, className, gap = "gap-6" }: { children: ReactNode; className?: string; gap?: string }) => (
  <div className={cn("flex flex-col p-8", gap, className)}>{children}</div>
);

/** Низ модалки ЛК: светлая полоса с кнопками. */
export const AdminModalFooter = ({ children, className }: { children: ReactNode; className?: string }) => (
  <div className={cn("bg-neutrals-99 flex items-center gap-4 rounded-b-[14px] px-8 pb-6 pt-3", className)}>{children}</div>
);
